export default "__VITE_ASSET__CEmMX_jT__"